import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
/**
 * Terminus NavPlatformSwitcherMenu Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  hasSubNavItemsPipe,
  hideNavItemsPipe,
  isNavLinkPipe,
} from '../../pipes/nav.pipes';

import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { SvgComponent } from '@terminus-ui/svg';
import { interceptClickEvent } from '../../util/click-interceptor';
import { NavPlatformSwitcherMenuListComponent } from '../nav-platform-switcher-menu-list/nav-platform-switcher-menu-list.component';
import { NavItem, NavPlatformData } from './../../models/nav.model';

const demandscienceLogo = require('../../../images/demandscience-logo.svg');

const LOCAL_STORAGE_IMPERSONATION_KEY = 'hub-idp-impersonation-username';

@Component({
  selector: 'tux-nav-platform-switcher-menu',
  templateUrl: './nav-platform-switcher-menu.component.html',
  styleUrls: ['./nav-platform-switcher-menu.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    SvgComponent,
    isNavLinkPipe,
    hasSubNavItemsPipe,
    NavPlatformSwitcherMenuListComponent,
    hideNavItemsPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavPlatformSwitcherMenuComponent {
  @Input() platformData: NavPlatformData;
  @Input() domain: string; // top level domain
  @Input() homeLink: string = ''; // top level domain
  @Output() navClose = new EventEmitter<void>();

  onNavItemClick() {
    this.navClose.emit();
  }
  interceptClickEvent = interceptClickEvent;
  demandscienceLogo = demandscienceLogo;

  subdomain = window.location.hostname.split('.')[0];
  home = this.subdomain.includes('next') ? 'home-next' : 'home';
  protected readonly faCaretRight = faCaretRight;

  getHomeLink(): string {
    if (this.homeLink !== '') {
      return this.homeLink;
    }

    return `https://${this.home}.${this.domain}`;
  }

  getHref(href: string): string {
    const impersonationUser = window.localStorage.getItem(
      LOCAL_STORAGE_IMPERSONATION_KEY,
    );

    // create query param of impersonation state to persist across app change
    return impersonationUser ? `${href}?orgId=${impersonationUser}` : href;
  }

  onMouseEnter(platformItem: NavItem) {
    platformItem.showSubNav = true;
  }

  onMouseLeave(platformItem: NavItem) {
    platformItem.showSubNav = false;
  }
}
